import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export default function CommandsPlugin() {
  var commands = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  function onCommand(command, database, next) {
    var type = command.type,
        args = command.args;
    var fn = commands[type];
    if (!fn) return next();
    database.command.apply(database, [fn].concat(_toConsumableArray(args)));
  }

  function onConstruct(database, next) {
    for (var command in commands) {
      database.registerCommand(command);
    }

    return next();
  }

  return {
    onCommand: onCommand,
    onConstruct: onConstruct
  };
}